module.exports = __webpack_public_path__ + "static/media/finland-cover.c37f14eb.webp";